
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as loginHOGV2v2PINdTIHc7UC2kEvGCEOmL3_45VnFH_Nuw9GeeMMeta } from "/app/pages/auth/login.vue?macro=true";
import { default as info9z7fbo6X4T0DnXlkUf6MwwJUnngiWONnhvtzUgfe2tgMeta } from "/app/pages/profile/info.vue?macro=true";
import { default as registerP6kYPRY6AO3o2k9aPJs1KTHwpt17Hy4EvBog_g8SDPYMeta } from "/app/pages/auth/register.vue?macro=true";
import { default as notificationsB9uD7vf6BNbcGL3D9HpazycZMRkcPWG6ea6_45mQfWSE0Meta } from "/app/pages/notifications.vue?macro=true";
import { default as indexPYMehh1H3I51I_Jt_45B2w91jhAIWvwCrr7OI55V5sjLcMeta } from "/app/pages/profile/index.vue?macro=true";
import { default as securityW53vAqMxzUMph_45djztoqU8rMLjDFPUS0H8M_45wXHbGuIMeta } from "/app/pages/profile/security.vue?macro=true";
import { default as infoT_u9O6ljBjY4P9tBG6acsh2F_453e3QZCH17TcsJRk89oMeta } from "/app/pages/project/[id]/info.vue?macro=true";
import { default as _91_46_46_46tab_93ew7ew5xwGnd4tHacZrrO3kqDyaOJ7WrBJAmcSIOq5cAMeta } from "/app/pages/dashboard/[...tab].vue?macro=true";
import { default as indexeATN28ksh1oHKhSY403CAOA_jtje4OnMRgn1wZnKxAMMeta } from "/app/pages/project/[id]/index.vue?macro=true";
import { default as deviceszJ39CAEhF5LtQ5MIoLBvG76z2sAbrJV8lyrM1nR4G70Meta } from "/app/pages/project/[id]/devices.vue?macro=true";
import { default as objectsOvp0qJ15lD8js5xxwF0usVlhQ7IvaCynA119yVvS2BYMeta } from "/app/pages/project/[id]/objects.vue?macro=true";
import { default as topologyqwfXRPPjGtwJrCeYN_k15SjUHiRIJd7LeKg9m1isL9EMeta } from "/app/pages/project/[id]/topology.vue?macro=true";
import { default as index1FRUHQS3AJcEIF3jld5UJdRzEhpfkzyzIVma6nMQVGAMeta } from "/app/pages/profile/finances/index.vue?macro=true";
import { default as edoXo7yzzDvLW4c3625b74EsB_454WJVL97LU7Ctnwv_vk6wMeta } from "/app/pages/profile/requisites/edo.vue?macro=true";
import { default as bankKDkCD5_CHk9MXMJd_45ni75WtCVEHDpaM9V_wUDVYgoNIMeta } from "/app/pages/profile/requisites/bank.vue?macro=true";
import { default as extensionslwFlXUzCkUkOMiSMjq_bzffHFM03AyimxPcRX9fVkd4Meta } from "/app/pages/project/[id]/extensions.vue?macro=true";
import { default as indexn1ndmj9ClgXXPcWvlh_MoHXKIibiuehUt3bzAOm9JosMeta } from "/app/pages/profile/requisites/index.vue?macro=true";
import { default as all_45objectsvClI6pak2Vxyi61iL4uxgrJDWoQ2kE6FuF_456fQHD4wsMeta } from "/app/pages/project/[id]/all-objects.vue?macro=true";
import { default as documentsnWh0fO3Qh48L84Qkbbj0C7LqsE_45X9eL9BjzwE8ir9A8Meta } from "/app/pages/profile/finances/documents.vue?macro=true";
import { default as operationsdDxBa_45dYqv5tbLpAWu1_45vPs_IfjqV1M1tflbxitvZiMMeta } from "/app/pages/profile/finances/operations.vue?macro=true";
import { default as indexDJDRb2M4WiZbbeoyV0WVBeGj08S8G26C_v301fI1bSsMeta } from "/app/pages/project/[id]/services/index.vue?macro=true";
import { default as index5fuBRMebroVejJC0uwdbZsRe7ghjyT3aAGtDMh6LL1EMeta } from "/app/pages/project/[id]/administration/index.vue?macro=true";
import { default as rolesfnRY2OHHIyzBSwdjYix2WFYcihPDULS2oI_45Q_45kfD_csMeta } from "/app/pages/project/[id]/administration/roles.vue?macro=true";
import { default as mapvtwhIjOTKBSD8mLVa_lRRV7atm3cH5id29smaRTEMVcMeta } from "/app/pages/project/[id]/services/live-view/map.vue?macro=true";
import { default as indexx874ALOo4bC_45iOrynTZhT3u447noOjUCHyYELPT_3t4Meta } from "/app/pages/project/[id]/services/live-view/index.vue?macro=true";
import { default as archive3rYjOEiRYvMcQOqpqt_45AR_FIz49bOY64NWen3k07bfwMeta } from "/app/pages/project/[id]/services/live-view/archive.vue?macro=true";
import { default as settingslIyDnbAYhn6Xmf2C_45JFb_45t87QP6yukXZGV_45fGz0XAlAMeta } from "/app/pages/project/[id]/services/live-view/settings.vue?macro=true";
import { default as multi_45viewwy0yB1IoQyjK5MK0RAtXwT3_VzQbTPEd_TIz6mWjaH0Meta } from "/app/pages/project/[id]/services/live-view/multi-view.vue?macro=true";
import { default as online_45viewltFOqugkDuVY9bODsTXt8SLxgFvFdDjTT_Y__451BBTisMeta } from "/app/pages/project/[id]/services/live-view/online-view.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: loginHOGV2v2PINdTIHc7UC2kEvGCEOmL3_45VnFH_Nuw9GeeMMeta || {},
    component: () => import("/app/pages/auth/login.vue")
  },
  {
    name: "profile-info",
    path: "/profile/info",
    meta: info9z7fbo6X4T0DnXlkUf6MwwJUnngiWONnhvtzUgfe2tgMeta || {},
    component: () => import("/app/pages/profile/info.vue")
  },
  {
    name: "auth-register",
    path: "/auth/register",
    meta: registerP6kYPRY6AO3o2k9aPJs1KTHwpt17Hy4EvBog_g8SDPYMeta || {},
    component: () => import("/app/pages/auth/register.vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    component: () => import("/app/pages/notifications.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/app/pages/profile/index.vue")
  },
  {
    name: "profile-security",
    path: "/profile/security",
    meta: securityW53vAqMxzUMph_45djztoqU8rMLjDFPUS0H8M_45wXHbGuIMeta || {},
    component: () => import("/app/pages/profile/security.vue")
  },
  {
    name: "project-id-info",
    path: "/project/:id()/info",
    component: () => import("/app/pages/project/[id]/info.vue")
  },
  {
    name: "dashboard-tab",
    path: "/dashboard/:tab(.*)*",
    meta: _91_46_46_46tab_93ew7ew5xwGnd4tHacZrrO3kqDyaOJ7WrBJAmcSIOq5cAMeta || {},
    component: () => import("/app/pages/dashboard/[...tab].vue")
  },
  {
    name: "project-id",
    path: "/project/:id()",
    meta: indexeATN28ksh1oHKhSY403CAOA_jtje4OnMRgn1wZnKxAMMeta || {},
    component: () => import("/app/pages/project/[id]/index.vue")
  },
  {
    name: "project-id-devices",
    path: "/project/:id()/devices",
    component: () => import("/app/pages/project/[id]/devices.vue")
  },
  {
    name: "project-id-objects",
    path: "/project/:id()/objects",
    meta: objectsOvp0qJ15lD8js5xxwF0usVlhQ7IvaCynA119yVvS2BYMeta || {},
    component: () => import("/app/pages/project/[id]/objects.vue")
  },
  {
    name: "project-id-topology",
    path: "/project/:id()/topology",
    component: () => import("/app/pages/project/[id]/topology.vue")
  },
  {
    name: "profile-finances",
    path: "/profile/finances",
    meta: index1FRUHQS3AJcEIF3jld5UJdRzEhpfkzyzIVma6nMQVGAMeta || {},
    component: () => import("/app/pages/profile/finances/index.vue")
  },
  {
    name: "profile-requisites-edo",
    path: "/profile/requisites/edo",
    meta: edoXo7yzzDvLW4c3625b74EsB_454WJVL97LU7Ctnwv_vk6wMeta || {},
    component: () => import("/app/pages/profile/requisites/edo.vue")
  },
  {
    name: "profile-requisites-bank",
    path: "/profile/requisites/bank",
    meta: bankKDkCD5_CHk9MXMJd_45ni75WtCVEHDpaM9V_wUDVYgoNIMeta || {},
    component: () => import("/app/pages/profile/requisites/bank.vue")
  },
  {
    name: "project-id-extensions",
    path: "/project/:id()/extensions",
    component: () => import("/app/pages/project/[id]/extensions.vue")
  },
  {
    name: "profile-requisites",
    path: "/profile/requisites",
    meta: indexn1ndmj9ClgXXPcWvlh_MoHXKIibiuehUt3bzAOm9JosMeta || {},
    component: () => import("/app/pages/profile/requisites/index.vue")
  },
  {
    name: "project-id-all-objects",
    path: "/project/:id()/all-objects",
    component: () => import("/app/pages/project/[id]/all-objects.vue")
  },
  {
    name: "profile-finances-documents",
    path: "/profile/finances/documents",
    meta: documentsnWh0fO3Qh48L84Qkbbj0C7LqsE_45X9eL9BjzwE8ir9A8Meta || {},
    component: () => import("/app/pages/profile/finances/documents.vue")
  },
  {
    name: "profile-finances-operations",
    path: "/profile/finances/operations",
    meta: operationsdDxBa_45dYqv5tbLpAWu1_45vPs_IfjqV1M1tflbxitvZiMMeta || {},
    component: () => import("/app/pages/profile/finances/operations.vue")
  },
  {
    name: "project-id-services",
    path: "/project/:id()/services",
    meta: indexDJDRb2M4WiZbbeoyV0WVBeGj08S8G26C_v301fI1bSsMeta || {},
    component: () => import("/app/pages/project/[id]/services/index.vue")
  },
  {
    name: "project-id-administration",
    path: "/project/:id()/administration",
    meta: index5fuBRMebroVejJC0uwdbZsRe7ghjyT3aAGtDMh6LL1EMeta || {},
    component: () => import("/app/pages/project/[id]/administration/index.vue")
  },
  {
    name: "project-id-administration-roles",
    path: "/project/:id()/administration/roles",
    meta: rolesfnRY2OHHIyzBSwdjYix2WFYcihPDULS2oI_45Q_45kfD_csMeta || {},
    component: () => import("/app/pages/project/[id]/administration/roles.vue")
  },
  {
    name: "project-id-services-live-view-map",
    path: "/project/:id()/services/live-view/map",
    meta: mapvtwhIjOTKBSD8mLVa_lRRV7atm3cH5id29smaRTEMVcMeta || {},
    component: () => import("/app/pages/project/[id]/services/live-view/map.vue")
  },
  {
    name: "project-id-services-live-view",
    path: "/project/:id()/services/live-view",
    meta: indexx874ALOo4bC_45iOrynTZhT3u447noOjUCHyYELPT_3t4Meta || {},
    component: () => import("/app/pages/project/[id]/services/live-view/index.vue")
  },
  {
    name: "project-id-services-live-view-archive",
    path: "/project/:id()/services/live-view/archive",
    meta: archive3rYjOEiRYvMcQOqpqt_45AR_FIz49bOY64NWen3k07bfwMeta || {},
    component: () => import("/app/pages/project/[id]/services/live-view/archive.vue")
  },
  {
    name: "project-id-services-live-view-settings",
    path: "/project/:id()/services/live-view/settings",
    meta: settingslIyDnbAYhn6Xmf2C_45JFb_45t87QP6yukXZGV_45fGz0XAlAMeta || {},
    component: () => import("/app/pages/project/[id]/services/live-view/settings.vue")
  },
  {
    name: "project-id-services-live-view-multi-view",
    path: "/project/:id()/services/live-view/multi-view",
    meta: multi_45viewwy0yB1IoQyjK5MK0RAtXwT3_VzQbTPEd_TIz6mWjaH0Meta || {},
    component: () => import("/app/pages/project/[id]/services/live-view/multi-view.vue")
  },
  {
    name: "project-id-services-live-view-online-view",
    path: "/project/:id()/services/live-view/online-view",
    meta: online_45viewltFOqugkDuVY9bODsTXt8SLxgFvFdDjTT_Y__451BBTisMeta || {},
    component: () => import("/app/pages/project/[id]/services/live-view/online-view.vue")
  }
]